const {colors} = require('@apollo/space-kit/colors');

exports.colors = {
  primary: colors.indigo.dark,
  primaryDark: colors.indigo.darker,
  primaryLight: colors.indigo.lighter,
  hyperlink: colors.blue.base,
  secondary: colors.pink.base,
  tertiary: colors.teal.dark,
  tertiaryLight: colors.teal.base,
  divider: colors.silver.dark,
  backgroundPure: colors.white,
  background: colors.silver.light,
  background2: colors.silver.base,
  backgroundNotice: colors.yellow.lighter,
  text1: colors.black.lighter,
  text2: colors.grey.dark,
  text3: colors.grey.light,
  text4: colors.silver.darker,
  textNotice: colors.yellow.darkest,
  warning: colors.yellow.base,
  shadow: colors.black.darker,
  highlight: colors.blue.base,
  highlight2: colors.blue.lighter,
  highlight3: colors.blue.lightest,
  hoverOpacity: 0.8
};
